

import { getOnlineBookingApi } from 'api';
import { MainPopup } from 'components/core';
import React, { createContext, useContext } from 'react';
import { OnlineBookingLocale } from "./OnlineBookingLocale";
import { OnlineBookingTheme } from "./OnlineBookingTheme";
import { useParams } from 'react-router';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useSelector } from 'react-redux';

const OnlineBookingContext = createContext(null);

const useOnlineBookingApi = () => useContext(OnlineBookingContext).api;
const useOnlineBookingPopup = () => useContext(OnlineBookingContext).MainPopup;

const OnlineBookingShell = ({ language, locales, recaptchaState, children }) => {
    // RC TODO: change all journeyGuidFromUrl or journeyGuid varbles to identity
    const journeyGuidFromApi = useSelector((state) => state.current.userData.journeyGUID);
    const processGUIDFromApi = useSelector((state) => state.current.userData.processGUID);
    const customerGUIDFromJWT = useSelector((state) => state.current.userData.customerGUID);
    const clientStateData = useSelector((state) => state.current.userData.clientStateData);

    const { journeyGuidFromUrl } = useParams();
    const { lngCode } = language;
    const { executeRecaptcha } = useGoogleReCaptcha();

    const api = getOnlineBookingApi(journeyGuidFromUrl, processGUIDFromApi, lngCode, executeRecaptcha, clientStateData, customerGUIDFromJWT, journeyGuidFromApi);

    if (recaptchaState && !executeRecaptcha) return null;

    const providerValue = { api, MainPopup };

    return (
        <OnlineBookingLocale locales={locales} current={lngCode}>
            <OnlineBookingTheme lngCode={lngCode} >
                <OnlineBookingContext.Provider value={providerValue}>
                    {children}
                </OnlineBookingContext.Provider>
            </OnlineBookingTheme>
        </OnlineBookingLocale>
    );
}

export { OnlineBookingShell, useOnlineBookingApi, useOnlineBookingPopup }